import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DeferredFragmentIdentifierClass;
function DeferredFragmentIdentifier() {
  if (DeferredFragmentIdentifierClass === VOID) {
    class $ {
      constructor(path, label) {
        this.f47_1 = path;
        this.g47_1 = label;
      }
      toString() {
        return 'DeferredFragmentIdentifier(path=' + toString(this.f47_1) + ', label=' + this.g47_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.f47_1);
        result = imul(result, 31) + (this.g47_1 == null ? 0 : getStringHashCode(this.g47_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeferredFragmentIdentifier()))
          return false;
        if (!equals(this.f47_1, other.f47_1))
          return false;
        if (!(this.g47_1 == other.g47_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeferredFragmentIdentifier');
    DeferredFragmentIdentifierClass = $;
  }
  return DeferredFragmentIdentifierClass;
}
//region block: exports
export {
  DeferredFragmentIdentifier as DeferredFragmentIdentifieryfmj5mbsp1mh,
};
//endregion

//# sourceMappingURL=DeferredFragmentIdentifier.mjs.map
